import React from 'react';
import { Redirect } from 'react-router-dom';

import isClient from 'commons/isClient';
import useUserData from 'data-hooks/useUserData';
import useIsBrowser from 'hooks/useIsBrowser';
import isNewConsumerApp from 'commons/isNewConsumerApp';

const withLoginPage = WrappedComponent => props => {
  const isBrowser = useIsBrowser();
  const { loading: isUserLoading, isLoggedIn } = useUserData();

  if (isUserLoading)
    return (
      <div className="text-lg font-bold flex items-center justify-center">
        Loading...
      </div>
    );

  // In new Consumer app, we should only redirect if component has been mounted
  // in browser to avoid SSR errors, but in the old app we use isClient() to
  // retain existing behavior
  const shouldRedirect =
    !isLoggedIn && (isNewConsumerApp ? isBrowser : isClient());

  if (shouldRedirect) {
    const { search, pathname } = window.location;
    const redirect = `redirect=${pathname}`;
    const redirectTo = search ? `${search}&${redirect}` : `?${redirect}`;

    return <Redirect to={`/sign-in/${redirectTo}`} />;
  }

  return <WrappedComponent {...props} />;
};

export default withLoginPage;
